module.exports = "/img/_/_/_/assets/images/creeper/book/uncommon//18.jpg?a0a6ed92d4cc5fc9a0c973815791e854";